import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const featureCards = [
  {
    icon: 'bi-lightning-charge-fill',
    title: 'Edição em tempo real',
    description: 'As alterações da lista aparecem sem recarregar a página.',
  },
  {
    icon: 'bi-diagram-3-fill',
    title: 'Categorias flexíveis',
    description: 'Separe compras por setor e alterne entre unidade e peso.',
  },
  {
    icon: 'bi-people-fill',
    title: 'Compartilhamento rápido',
    description: 'Convide outras pessoas para comprar junto com você.',
  },
];

const workflowSteps = [
  'Crie listas com um nome simples e objetivo.',
  'Organize produtos soltos ou dentro de categorias.',
  'Acompanhe totais, progresso e itens concluídos durante a compra.',
];

const LandingPage = () => {
  const { authData } = useContext(AuthContext);
  const { token, userName } = authData;
  const firstName = userName?.trim() ? userName.trim().split(' ')[0] : 'você';

  return (
    <section className="page-section landing-page">
      <div className="hero-grid">
        <div className="surface-card hero-panel hero-panel--main">
          <span className="eyebrow">
            {token ? `Bem-vindo de volta, ${firstName}` : 'Planejamento de compras'}
          </span>
          <h1 className="section-title">
            Seu painel de compras ficou mais claro, rápido e organizado.
          </h1>
          <p className="section-copy">
            Centralize listas, acompanhe valores, compartilhe compras da casa e
            mantenha tudo sincronizado em uma interface mais atual.
          </p>

          <div className="hero-actions">
            {token ? (
              <>
                <Link to="/listas" className="primary-button">
                  Abrir minhas listas
                </Link>
                <Link to="/perfil" className="subtle-button">
                  Ver meu perfil
                </Link>
              </>
            ) : (
              <>
                <Link to="/register" className="primary-button">
                  Criar conta
                </Link>
                <Link to="/login" className="subtle-button">
                  Fazer login
                </Link>
              </>
            )}
          </div>

          <div className="hero-highlight-grid">
            <div className="metric-card">
              <span className="metric-label">Fluxo</span>
              <strong className="metric-value">Mais direto</strong>
            </div>
            <div className="metric-card">
              <span className="metric-label">Tema</span>
              <strong className="metric-value">Claro e escuro</strong>
            </div>
            <div className="metric-card">
              <span className="metric-label">Compra</span>
              <strong className="metric-value">Colaborativa</strong>
            </div>
          </div>
        </div>

        <div className="surface-card hero-panel hero-panel--aside">
          <div className="preview-stack">
            <div className="preview-card preview-card--accent">
              <span className="preview-card__title">Resumo rápido</span>
              <div className="preview-card__row">
                <span>Itens concluídos</span>
                <strong>12 / 18</strong>
              </div>
              <div className="preview-card__row">
                <span>Valor estimado</span>
                <strong>R$ 186,40</strong>
              </div>
              <div className="preview-card__row">
                <span>Categorias</span>
                <strong>Feira, mercado, limpeza</strong>
              </div>
            </div>

            <div className="preview-card">
              <span className="preview-card__title">Fluxo pensado para uso real</span>
              <p>
                Ideal para compras recorrentes, divisão por setores e edição
                durante a ida ao mercado.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="feature-grid">
        {featureCards.map((feature) => (
          <article className="surface-card feature-card" key={feature.title}>
            <span className="feature-card__icon">
              <i className={`bi ${feature.icon}`}></i>
            </span>
            <h2>{feature.title}</h2>
            <p>{feature.description}</p>
          </article>
        ))}
      </div>

      <div className="surface-card workflow-panel">
        <div>
          <span className="eyebrow">Como funciona</span>
          <h2 className="section-subtitle">Um fluxo simples o suficiente para usar todo dia</h2>
        </div>
        <div className="workflow-grid">
          {workflowSteps.map((step, index) => (
            <div className="workflow-step" key={step}>
              <span>{String(index + 1).padStart(2, '0')}</span>
              <p>{step}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingPage;
